module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"to_top":"Вверх"},"en":{"to_top":"Go up"}}')
  delete Component.options._Ctor
}
